export default __webpack_public_path__ + "static/media/infra-2.d784df12.webp";